import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { extractErrorMessage } from '../../../../utils/errorUtils';
import { FormErrorContext } from '../../../../FormErrorContext';
/**
 *
 */
export default function FormField(props) {
    var intl = useIntl();
    var children = props.children, errors = props.errors;
    var formErrorContext = useContext(FormErrorContext);
    // Use from props, if doesn't exist, use from context, fallback empty object
    var errorObject = errors ? errors : (formErrorContext ? formErrorContext.errors : {});
    // Start error message
    var errorMessage = '';
    // Loop through children, scan for errors where child name props == error field name
    var childrenWithErrors = React.Children.map(children, function (child) {
        if (child) {
            var msg = extractErrorMessage(errorObject, child.props['data-errorHandler'] ? child.props['data-errorHandler'] : child.props.name, intl);
            // If an error exists, clone the child, and add an error class to className prop
            if (msg) {
                errorMessage += (errorMessage.length > 0 ? ' / ' + msg : msg);
                var className = child.props.className ? child.props.className + ' is-invalid' : 'is-invalid';
                return React.cloneElement(child, { className: className });
            }
            else {
                return child;
            }
        }
    });
    // Create error div when error exists
    var error = errorMessage.length > 0 &&
        React.createElement("div", { className: "form-field__error mt-1 w-100" },
            React.createElement("span", { className: "text-danger" }, errorMessage + ''));
    return (React.createElement("div", { className: "form-field d-flex flex-wrap ".concat(props.className ? props.className : '') },
        childrenWithErrors,
        error));
}
FormField.displayName = 'FormField';
